import { render, staticRenderFns } from "./ApplicationFormIndividualCreditTrust.vue?vue&type=template&id=92d67bea&scoped=true"
import script from "./ApplicationFormIndividualCreditTrust.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormIndividualCreditTrust.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationFormIndividualCreditTrust.vue?vue&type=style&index=0&id=92d67bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d67bea",
  null
  
)

export default component.exports